
import { Dialog } from "@/components/ui/dialog";
import { useEffect } from "react";
import { ManageSubscriptionContent } from "./subscription/ManageSubscriptionContent";
import { SubscriptionPlansContent } from "./subscription/SubscriptionPlansContent";
import { useSubscription } from "@/hooks/useSubscription";
import { SubscriptionTier } from "@/types/subscription";

const tiers: SubscriptionTier[] = [
  {
    name: "Free",
    price: null,
    priceId: null,
    queueLimit: 1,
    description: "Perfect for trying out the platform",
    features: [
      "No credit card needed",
      "1 queue",
      "Real-time updates",
      "Basic analytics"
    ],
    isFree: true
  },
  {
    name: "Basic",
    price: 15,
    priceId: "price_1Qgn4oDBBPKrg2Hy4p4SrTZn",
    queueLimit: 3,
    description: "Perfect for small businesses",
    features: [
      "Up to 3 queues",
      "Real-time updates",
      "Email support",
      "Analytics",
    ],
  },
  {
    name: "Pro",
    price: 19,
    priceId: "price_1QgnAUDBBPKrg2HyibzxNWxh",
    queueLimit: 5,
    description: "Ideal for growing businesses",
    features: [
      "Up to 5 queues",
    ],
  },
  {
    name: "Enterprise",
    price: 30,
    priceId: "price_1QgnCuDBBPKrg2HyvUVr5WMX",
    queueLimit: 10,
    description: "Best for large organizations",
    features: [
      "Up to 10 queues",
    ],
  },
];

interface SubscriptionDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  mode: "manage" | "subscribe";
}

export function SubscriptionDialog({ open, onOpenChange, mode }: SubscriptionDialogProps) {
  const { state, handleSubscribe, handleManageSubscription } = useSubscription();

  useEffect(() => {
    if (!open) {
      console.log('Dialog closed, cleaning up state');
    }
  }, [open]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      {mode === "manage" ? (
        <ManageSubscriptionContent
          isLoading={state.isLoading}
          onManageSubscription={handleManageSubscription}
        />
      ) : (
        <SubscriptionPlansContent
          tiers={tiers}
          isLoading={state.isLoading}
          selectedTier={state.selectedTier}
          onSubscribe={handleSubscribe}
        />
      )}
    </Dialog>
  );
}
